<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Attention
      </h2>
    </template>
    <template #modal-body>
      <div class="Notice Notice--warning">
        <h3>Reset Flows</h3>
        <p>Once each flow is deleted they cannot be recovered.</p>
        <p>Are you sure you want to reset the flows?</p>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :class="[{'is-loading': ui.submitLoading }, 'Button Button--danger']"
          @click="handleReset"
        >
          Reset
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapActions } from 'vuex';
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    event: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      ui: {
        submitLoading: false,
      },
    };
  },
  methods: {
    ...mapActions('events', {
      resetFlows: 'resetFlows',
    }),
    handleReset() {
      this.ui.submitLoading = true;
      this.resetFlows(this.event.id)
        .then(({ data }) => {
          // success
          this.isOpen = false;
          this.$emit('reset-flows:success');
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'success',
          });
          this.ui.submitLoading = false;
        })
        .catch(({ data }) => {
          this.ui.submitLoading = false;
          this.$bus.$emit('global-dismiss-modal'); // Dismiss modal
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'warning',
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.BorderedHeaderModal {
  h3, p {
    color: #A94442
  }

  .Notice {
    margin-bottom: 0;
  }
}
</style>
